import { extensionRedirectPath } from '$extensionSrc/consts/urlConsts'

export function getExtensionRedirectUrl(
  path: string,
  queryParams: { [key: string]: any } | null = null,
): string {
  let base
  if (window) {
    base = new URL(window.location.href).origin
  }

  const url = new URL(extensionRedirectPath, base)
  url.searchParams.set('path', path)
  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => {
      url.searchParams.set(key, value)
    })
  }
  return url.href
}

// Extension page URLs
export function getExtensionUrl(
  path: string,
  browser: 'firefox' | 'chrome' | 'edge',
  runtimeExtensionId: string,
  queryParams: { [key: string]: any } | null = null,
  hash: string | null = null,
) {
  const extensionId = runtimeExtensionId
  const url_prefix =
    browser === 'firefox' ? 'moz-extension://' : 'chrome-extension://'
  const url = new URL(path, `${url_prefix}${extensionId}/`)
  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => {
      url.searchParams.set(key, value)
    })
  }
  if (hash) {
    url.hash = hash
  }
  return url.href
}
